export default __webpack_public_path__ + "4f89da51b772c626fd79b3db88e48125.png";